export default __webpack_public_path__ + "static/media/rule.3ee041f2.svg";